
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "MCOSF",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/MCOSF.vue